import "./style.scss";
// import  from "../../../target-enterprises/selected/org-config.js";

window.app.config([
  "$stateProvider",
  function($stateProvider) {
    $stateProvider.state("login", {
      url: "/login",
      template: require("./index.html"),
      controller: "LoginCtrl"
    });
  }
]);

/* jslint browser: true,  devel: true */
window.app.controller("LoginCtrl", [
  "$scope",
  "$element",
  "$state",
  "$stateParams",
  "$http",
  "$location",
  "toastr",
  "$utils",
  function(
    $scope,
    $element,
    $state,
    $stateParams,
    $http,
    $location,
    toastr,
    $utils
  ) {
    console.log("LoginCtrl:init");
    $scope.error = "";
    // api.Login.token = null;

    console.warn("ORGCONFIG", window.orgConfig);

    var locationState = $location.state();
    var notifyLogout = locationState && locationState.notify;

    // TODO maybe do this differently. Did it this way because $location.search()
    // requires some config tweaking to work, apparently
    // var qs = window.location.search
    //   .substr(1)
    //   .split("&")
    //   .map(s => s.split("="))
    //   .reduce((o, p) => {
    //     o[p[0]] = p[1];
    //     return o;
    //   }, {});
    const webReturnURL =
      window.location.href.substr(0, window.location.href.indexOf("/", 8)) +
      "/";
    const mobileReturnURL = "https://assets.getcueapp.com/"; // TODO move to config
    const retURL = window.isMobileApp ? mobileReturnURL : webReturnURL;

    const http = $utils($scope).withRetries($http, 2, 500);

    let loginMethods;
    http({
      url:
        API_URL +
        "authentication/methods/" +
        window.orgConfig.orgCode +
        "?redirectUri=" +
        encodeURIComponent(retURL)
    }).then(
      res => {
        loginMethods = res.data;
        $scope.methodOptions = loginMethods.map(m => ({
          id: m.id,
          text: m.loginButtonText
        }));

        $scope.chosenMethodId = $scope.methodOptions[0].id;
        $scope.chosenMethod = () =>
          loginMethods.find(m => m.id === $scope.chosenMethodId);
      },
      error => {
        console.log(error);
        toastr.error("Unable to fetch login options");
        setTimeout(() => {
          window.location.href = "auth_error.html";
        }, 2000);
      }
    );

    $scope.credentials = {
      username: "",
      password: ""
    };

    $scope.toggleChoices = () => {
      $scope.showChoices = !$scope.showChoices;
    };

    $scope.setChoice = v => {
      $scope.chosenMethodId = v;
      $scope.toggleChoices();
      const m = $scope.chosenMethod();
      if (m.url) {
        window.location.href = m.url;
      }
    };

    $scope.reset = function() {
      $scope.error = "";
    };

    $scope.login = function(form) {
      $scope.credentials.password = ($scope.credentials.password || "").trim();
      $scope.credentials.username = ($scope.credentials.username || "").trim();
      if (!form.$valid) {
        angular.forEach(["login-pw", "login-user"], function(field) {
          form[field].$dirty = true;
        });
        $scope.showInvalid = true;
        setTimeout(function() {
          $scope.$applyAsync(function() {
            $scope.showInvalid = false;
          });
        }, 1600);
        return;
      }

      const method = $scope.chosenMethod();
      $scope.loginInProcess = "started";
      $http({
        url:
          API_URL +
          "authentication/upass/" +
          window.orgConfig.orgCode +
          "?integrationId=" +
          method.id,
        method: "POST",
        data: {
          email: $scope.credentials.username,
          password: $scope.credentials.password
        }
      }).then(
        res => {
          window.location.href =
            "?access_token=" + res.data.authenticationToken;
        },
        error => {
          console.error(error);
          $scope.loginInProcess = undefined;
          toastr.error("Unable to login - check your credentials");
        }
      );
      // api.Login.login($scope.credentials).then(
      //   function success() {
      //     console.log("success");
      //     window.location.hash = "#/";
      //     // $state.go('container');
      //   },
      //   function failure() {
      //     $scope.loginInProcess = undefined;
      //     $scope.error = "Unable to login, check your credentials";
      //   }
      // );
    };

    $scope.showVersion = function() {
      toastr.info("Application Version: " + $scope.$root.GIT_VERSION);
    };

    $element.on("$destroy", function() {
      $element.off();
      setTimeout(function() {
        $scope.$destroy();
      }, 1);
    });

    if (notifyLogout) {
      if (window.history.replaceState) {
        window.history.replaceState(
          undefined,
          window.title,
          window.location.pathname + window.location.hash
        );
      }
      toastr.warning("Login ticket has expired, please login again", {
        timeOut: 5000,
        extendedTimeOut: 10000,
        showDuration: "300",
        hideDuration: "1000",
        tapToDismiss: true
      });
    }
  }
]);



// WEBPACK FOOTER //
// ./src/apps/login/index.js